<template>
  <div class="about">
    <table class="about__data">
      <tbody>
        <tr>
          <td>App Version</td>
          <td>{{ appVersion }}</td>
        </tr>
        <tr>
          <td>Backend API Version</td>
          <td>{{ backendApiVersion }}</td>
        </tr>
        <tr>
          <td>CRM API Version</td>
          <td>{{ reemApiVersion }}</td>
        </tr>
        <tr>
          <td>Cube API Version</td>
          <td>{{ cubeApiVersion }}</td>
        </tr>
      </tbody>
    </table>

    <div>
      Letzte Änderungen<br />
      <ul>
        <li>
          App: 3.2.1 (04.11.2026)<br />
          <ul>
            <li>Bugfix Trading-Details auf "Aktuell" werden nicht korrekt angezeigt.</li>
          </ul>
        </li>
        <li>
          App: 3.2.0 (01.11.2026)<br />
          <ul>
            <li>Bugfix Diagrammdarstellung bei Sommer-Winterzeit-Umstellung.</li>
          </ul>
        </li>
        <li>
          App: 3.1.8 (21.0.2026)<br />
          <ul>
            <li>Bugfixes.</li>
          </ul>
        </li>
        <li>
          App: 3.1.7 (25.6.2026)<br />
          <ul>
            <li>Bugfixes ("Meine Daten" updaten).</li>
          </ul>
        </li>
        <li>
          App: 3.1.6 (22.6.2026)<br />
          <ul>
            <li>Whatsapp-Kontaktmöglichkeit hinzugefügt (siehe "Meine Einstellungen").</li>
          </ul>
        </li>
        <li>
          App: 3.1.5 (15.6.2026)<br />
          <ul>
            <li>Diverse Bug-Fixes.</li>
          </ul>
        </li>
        <li>
          App: 3.1.4 (11.6.2026)<br />
          <ul>
            <li>Diverse Bug-Fixes.</li>
          </ul>
        </li>
        <li>
          App: 3.1.3 (30.4.2026)<br />
          <ul>
            <li>Zendure-Speicher Batterie-Ladestand kann im Chart angezeigt werden.</li>
          </ul>
        </li>
        <li>
          App: 3.1.2 (30.4.2026)<br />
          <ul>
            <li>Support für Energiegemeinschaften.</li>
          </ul>
        </li>
        <li>
          App: 3.1.1 (30.4.2026)<br />
          <ul>
            <li>Interne Performance-Optimierungen.</li>
          </ul>
        </li>
        <li>
          App: 3.0.16 (29.4.2026)<br />
          <ul>
            <li>Filter für Spenden-Empfänger in der Map hinzugefügt.</li>
          </ul>
        </li>
        <li>
          App: 3.0.15 (27.3.2026)<br />
          <ul>
            <li>Links im Beschreibungstext unter "Meine Daten" werden nun auf der Karte als echte Links dargestellt.</li>
          </ul>
        </li>
        <li>
          App: 3.0.14 (17.3.2026)<br />
          <ul>
            <li>Bug-Fixes Einstellungen zeigten nur weiße Seite</li>
          </ul>
        </li>
        <li>
          App: 3.0.13 (13.3.2026)<br />
          <ul>
            <li>Bug-Fixes im Verlauf</li>
          </ul>
        </li>
        <li>
          App: 3.0.12 (9.3.2026)<br />
          <ul>
            <li>Batterie-SOC-Werte werden im Tages-Chart wird angzeigt, falls verfügbar</li>
          </ul>
        </li>
        <li>
          App: 3.0.11 (9.3.2026)<br />
          <ul>
            <li>Bug-Fix: Charts verschwinden nach kurzer Zeit</li>
          </ul>
        </li>
        <li>
          App: 3.0.10 (5.3.2026)<br />
          <ul>
            <li>Bug-Fix: Pie Charts werden falsch dargestellt</li>
          </ul>
        </li>
        <li>
          App: 3.0.9 (4.3.2026)<br />
          <ul>
            <li>Bug-Fix: Preiskurve im Verlauf um eine Stunde versetzt</li>
            <li>Bug-Fix: hoher Kontrast funktionierte nicht</li>
          </ul>
        </li>
        <li>
          App: 3.0.8 (11.9.2025)<br />
          <ul>
            <li>Freundschaftwerbung per WhatsApp</li>
          </ul>
        </li>
        <li>
          App: 3.0.7 (8.9.2025)<br />
          <ul>
            <li>Bezeichnung für die Einspeisung in der eFriends Map ist jetzt korrekt</li>
          </ul>
        </li>
        <li>
          App: 3.0.6 (18.8.2025)<br />
          <ul>
            <li>Fehler beim Vergeben von Sonderpreisen behoben</li>
          </ul>
        </li>
        <li>
          App: 3.0.5 (6.8.2025)<br />
          <ul>
            <li>Fehler in der Verlaufsanzeigeanzeige behoben</li>
          </ul>
        </li>
        <li>
          App: 3.0.4 (17.7.2025)<br />
          <ul>
            <li>Fehler in der Preisanzeige behoben</li>
          </ul>
        </li>
        <li>
          App: 3.0.3 (1.7.2025)<br />
          <ul>
            <li>eFriends Netzkostenersparnis</li>
          </ul>
        </li>
        <li>
          App: 3.0.2 (27.6.2025)<br />
          <ul>
            <li>Maintenance-Update</li>
          </ul>
        </li>
        <li>
          App: 3.0.1 (25.6.2025)<br />
          <ul>
            <li>Fehler in der Passwort-vergessen-Funktion behoben</li>
          </ul>
        </li>
        <li>
          App: 3.0.0 (24.6.2025)<br />
          <ul>
            <li>Migration auf vue3</li>
          </ul>
        </li>
        <li>
          App: 2.7.7 (10.6.2025)<br />
          <ul>
            <li>Umstellung auf den neuen Konfigurationsassistenten.</li>
          </ul>
        </li>
        <li>
          App: 2.7.6 (26.5.2025)<br />
          <ul>
            <li>Der Float-Preis wird im Verlauf angezeigt.</li>
          </ul>
        </li>
        <li>
          App: 2.7.4 (08.10.2024)<br />
          <ul>
            <li>
              Verbesserungen an der Tour, damit sich neue User noch einfacher
              zurechtfinden.
            </li>
          </ul>
        </li>
        <li>
          App: 2.7.3 (30.11.2023)<br />
          <ul>
            <li>Das Smart Home Feature findet ihr nun bei clever-PV.</li>
          </ul>
        </li>
        <li>
          App: 2.7.2 (27.11.2023)<br />
          <ul>
            <li>
              <strong>Benachrichtigung für Cube Probleme</strong><br />
              Sollte Cube bzw. WATCH+ nicht mehr erreichbar sein, wird eine
              Notifikation erzeugt, die in den Einstellungen per Push-Nachricht
              oder per Email empfangen werden kann.
            </li>
          </ul>
        </li>
        <li>
          App: 2.7.1 (25.10.2023)<br />
          <ul>
            <li>
              <strong>eFriends weiterempfehlen</strong><br />
              Unter Meine Daten gibt es eine Möglichkeit neue eFriends zu
              werben.
            </li>
            <li>
              <strong>Fehlerkorrektur</strong><br />
              Bei Änderung von Sonderpreisen konnte es vorkommen, dass dieser
              nicht sofort korrekt angezeigt wurde.
            </li>
          </ul>
        </li>
        <li>
          App: 2.7.0 (29.8.2023)<br />
          <ul>
            <li>
              <strong>API Key Manager</strong><br />
              eFriends haben nun die Möglichkeit API-Keys zu vergeben. Die
              Verwendung ist
              <a
                href="https://support.efriends.at/hc/de/articles/13102958854941"
                target="_blank"
              >hier <IconExternal
              /></a>
              beschrieben.
            </li>
          </ul>
        </li>
        <li>
          App: 2.6.7 (1.8.2023)<br />
          <ul>
            <li>
              <strong>Fehlerbehebung</strong><br />
              Die Darstellung der Prioritäten bei Konsumenten wurde nach
              Änderung nicht aktualisiert.
            </li>
          </ul>
        </li>
        <li>
          App: 2.6.6 (31.7.2023)<br />
          <ul>
            <li>
              <strong>Device Manager</strong><br />
              Die Monatsansicht wurde wieder aktiviert.
            </li>
            <li>
              <strong>Fehlerbehebung</strong><br />
              Bei Sonderpreisen wurde manchmal ein Speichern-Button angezeigt
              obwohl keine Änderung vorgenommen wurde.
            </li>
          </ul>
        </li>
        <li>
          App: 2.6.5 (17.7.2023)<br />
          <ul>
            <li>
              <strong>Device Manager</strong><br />
              Die Monatsansicht funktioniert zur Zeit nicht zuverlässig und wird
              daher temporär deaktiviert. Sie kommt wieder keine Frage.
            </li>
          </ul>
        </li>
        <li>
          App: 2.6.4 (28.3.2023)<br />
          <ul>
            <li>
              <strong>Darstellung mit hohem Kontrast</strong><br />
              In den Einstellungen gibt es eine Möglichkeit zur Darstellung mit
              hohem Kontrast. Dies aktiviert in der Verlaufskurve ein
              Farbschema, dass die Flächen besser unterscheidbar macht. Das
              Feature wird laufend verbessert.
            </li>
            <li>
              <strong>Watch und Watch+</strong><br />
              Helligkeit der Leuchten in der Watch ist nun konfigurierbar. Es
              gibt eine sonnenstandsabhängige Automatik aber auch eine
              zeitgesteuerte Helligkeitsoption.
            </li>
            <li>
              <strong>MAP</strong><br />
              Meine eFriends lassen sich ab jetzt auf der MAP filtern.
            </li>
            <li>
              <strong>Bugs</strong><br />
              Die Preiskurve ging beim besseren Tarif verloren.
            </li>
          </ul>
        </li>
        <li>
          App: 2.6.3 (13.3.2023)<br />
          <ul>
            <li>
              <strong>Bugs</strong><br />
              Die Preiskurve ging bei manchen Produzenten leider verloren.
            </li>
            <li>
              Verbindungen werden ab jetzt "fixiert" anstatt "gesperrt". Damit
              soll besser erklärt werden dass die Verbindung nicht aus dem
              trading gesperrt wird, sondern vor versehentlichen Löschen
              geschützt ist. Optimize Me KundInnen haben so eine Möglichkeit
              auch zu verhindern, dass die Verbindung durch Optimize Me
              "wegoptimiert" wird.
            </li>
          </ul>
        </li>
        <li>
          App: 2.6.2 (10.3.2023)<br />
          <ul>
            <li>
              <strong>Preiskurve</strong><br />
              Auf der Verlauf-Seite gibt es für alle Tarife (ausgenommen
              Floater) eine tagesaktuelle Preiskurve.
            </li>
            <li>Zähler und Inverter können auch wieder entfernt werden.</li>
          </ul>
        </li>
        <li>
          App: 2.6.1 (9.1.2023)<br />
          <ul>
            <li>
              <strong>Flex-Tarif Darstellung</strong><br />
              Flex-Tarif Preise inkl. USt
            </li>
          </ul>
        </li>
        <li>
          App: 2.6.0 (5.1.2023)<br />
          <ul>
            <li>
              <strong>Flex-Tarif</strong><br />
              KundInnen mit Flex-Tarif sehen die aktuellen stündlichen
              Flex-Preise in einem neuen Diagramm im Verlauf
            </li>
          </ul>
        </li>
        <li>
          App: 2.5.5 (5.12.2022)<br />
          <ul>
            <li>
              <strong>Bugfix</strong><br />
              Einige eFriends konnten sich nicht einloggen
            </li>
          </ul>
        </li>
        <li>
          App: 2.5.4 (1.12.2022)<br />
          <ul>
            <li>
              <strong>Like-System</strong><br />
              eFriends of the Month werden jeden Monat neu vergeben
            </li>
          </ul>
        </li>
        <li>
          App: 2.5.3 (3.11.2022)<br />
          <ul>
            <li>
              <strong>Like-System</strong><br />
              eFriends of the Month haben einen besonderen Pin als Auszeichnung
              bekommen.
            </li>
          </ul>
        </li>
        <li>
          App: 2.5.2 (19.10.2022)<br />
          <ul>
            <li>
              <strong>Like-System</strong><br />
              Du kannst nun einmal pro Monat deinen Produzenten ein "Like"
              spendieren, wenn du mit der Preisgestaltung oder der zur Verfügung
              gestellten Menge zufrieden bist.<br />
              In der Filter-Liste kann auch nach Likes sortiert werden.<br />
              Jedes Monat werden die Likes dann wieder zurückgesetzt um die
              Bewertungen immer aktuell zu halten.
            </li>
            <li>
              <strong>Meine Daten</strong><br />
              Dein Nickname kann nun direkt in der App selbst geändert / gewählt
              werden.
            </li>
          </ul>
        </li>
        <li>
          App: 2.5.1 (22.09.2022)<br />
          <ul>
            <li>
              <strong>Download</strong><br />
              Im Bereich Downloads können nun alle Messwerte deines Cubes auf
              Monatsbasis gesammelt als übersichtliches Excel-Sheet
              heruntergeladen werden.
            </li>
          </ul>
        </li>
        <li>
          App: 2.5.0 (10.08.2022)<br />
          <ul>
            <li>
              <strong>Smart Home Funktion</strong><br />
              Eine neue Funktion im eFriends Shop erlaubt nun die optimierte
              Steuerung von Wallboxen und Steckdosen mit Überschuss von der
              eigenen PV-Anlage oder durch Community Überschuss.
              <br />
              Details zur Einrichtung findest du im
              <a
                href="https://efriends.zendesk.com/hc/de/articles/8286284466321-Aktivierung-der-SMART-HOME-Funktion-in-der-eFriends-App"
                target="_blank"
              >Support Artikel <IconExternal /></a
              >.<br />
              Zudem gibt es noch einige
              <a
                href="https://efriends.zendesk.com/hc/de/articles/8289947631377-Erste-Schritte-mit-der-SMART-HOME-Funktion"
                target="_blank"
              >Tipps &amp; Tricks <IconExternal
              /></a>
              in einem weiteren Artikel.
            </li>
            <li>
              <strong>Verwaltung des Zählers</strong><br />
              Eingerichtete Drittzähler (Fronius, Shelly, etc.) sind nun nicht
              mehr im Device Manager, sondern im Menü unter Einstellungen zu
              finden.<br />
            </li>
            <li>
              <strong>Geräte</strong><br />
              Der Geräte Manager ist nun in 3 Abschnitte unterteilt:<br />
              Info: beschreibt die möglichen Funktionen<br />
              Manuell: der bisherige Device Manager für manuelles Schalten und
              Zeitschaltuhr mit myStrom Steckdosen<br />
              Smart: die neue Smart Home Funktion aus dem eFriends Shop
            </li>
          </ul>
        </li>
        <li>
          App: 2.4.0 (28.06.2022)<br /><a
          href="https://www.efriends.at/technik/update-in-der-efriends-app.html"
          target="_blank"
        >Zum Blogartikel</a
        >
          <ul>
            <li>
              <strong>Mehr Prio Stufen</strong><br />
              Statt bisher 3 Prio-Stufen (Hoch, Standard, Niedrig) können zur
              genaueren Justierung nun insgesamt 5 Prio-Stufen festgelegt
              werden.<br />
            </li>
            <li>
              <strong>Gesperrte Verbindungen</strong><br />
              Verbindungen können ab sofort auch gesperrt werden.<br />
            </li>
            <li>
              <strong>Device Manager</strong><br />
              Der Device Manager verwaltet nun auch Fronius Smart Meter /
              Wechselrichter sowie Shelly 3EM Smart Meter, die ebenso statt der
              eFriends Messung verwendet werden können. Der Klick auf „Geräte
              suchen“ führt dazu, dass die Geräte im lokalen Netzwerk gefunden
              werden.<br />
            </li>
            <!--<li>
              <strong>Meterless mit Lastprofilprognose</strong><br />
              Für eFriends-Kunden ohne aktive Messung gibt es das neue Produkt
              „Meterless“. Details dazu findest du im separaten Blogartikel.<br />
            </li>-->
            <li>
              <strong>Anzeige der Reststrompreise und Preiseinstellungen</strong
              ><br />
              Die App zeigt nun unter "eFriends" auch die Reststrompreise und
              Preisänderungen an (nur für eFriends-Kunden mit Standardtarif).<br />
            </li>
            <li>
              <strong>Watch Umschaltmöglichkeit</strong><br />
              In der App kann nun unter „Einstellungen“ die Watch-Anzeige selbst
              umgestellt werden.<br />
            </li>
            <li>
              <strong>Ersatzwertbildung</strong><br />
              Sollte die Messung ausfallen, handelt der Cube mit Ersatzwerten
              (Prognosewerten / Standardlastprofil des Netzbetreibers) weiter,
              um die Lücken zu verringern.<br />
            </li>
            <li>
              <strong>Sonstige Verbesserungen</strong><br />
              Jede Menge kleine Verbesserungen, Formulierungen, etc. die die
              Bedienung der App vereinfachen.<br />
            </li>
          </ul>
        </li>
        <li>
          App: 2.3.13 (16.03.2022)
          <ul>
            <li>
              <strong>Preis-Anzeige</strong><br />
              Verbesserung und Fehlerbehebung der Preisanzeige bei
              Sonderpreisen, künftigen Preisen und bei Kunden mit mehreren
              Verträgen.<br />
            </li>
          </ul>
        </li>
        <li>
          App: 2.3.12 (01.03.2022)
          <ul>
            <li>
              <strong>Shop</strong><br />
              Der Shop ist jetzt leichter erreichbar.<br />
            </li>
            <li>
              <strong>Tour</strong><br />
              Die Tour wurde verbessert und ist für bestehende User
              verfügbar.<br />
            </li>
            <li>
              <strong>Passwort vergessen</strong><br />
              Es sollte nun immer ein Feedback geben wenn die Email mit neuem
              Passwortvergabe-Link unterwegs ist.<br />
            </li>
          </ul>
        </li>
        <li>
          App: 2.3.11 (14.01.2022)
          <ul>
            <li>
              <strong>Fehlerbehebung</strong><br />
              Fehlerhafte Adresse in der App-Tour<br />
            </li>
            <li>
              <strong>Fehlerbehebung</strong><br />
              Bei kleinen Bezugsmengen wurde in der Ansicht "Mein Energiemix"
              oft noch der Wert des Vortages angezeigt.<br />
            </li>
          </ul>
        </li>
        <li>
          App: 2.3.10 (02.01.2022)
          <ul>
            <li>
              <strong>Fehlerbehebung</strong><br />
              Anpassung Filtereinstellung an Energiepreis<br />
            </li>
          </ul>
        </li>
        <li>
          App: 2.3.9 (21.12.2021)
          <ul>
            <li>
              <strong>Fehlerbehebung</strong><br />
              In manchen Fällen kam es bei Buchungen im
              <a href="/shop">eFriends-Shop</a> zu Fehlermeldungen bzw.
              Doppelbuchungen. Dieser Fehler wurde behoben.<br />
            </li>
          </ul>
        </li>
        <li>
          App: 2.3.8 (17.12.2021)
          <ul>
            <li>
              <strong>E-Mail Benachrichtigungen</strong><br />
              Benachrichtigungen können nun optional auch per E-Mail zugestellt
              werden (zu finden im Menüpunkt
              <a href="/settings">Einstellungen</a>).<br />
            </li>
            <li>
              <strong>Suchmöglichkeit im Filter</strong><br />
              In der Map kann im Filter nun auch nach Nicknames gesucht
              werden<br />
            </li>
          </ul>
        </li>
        <li>
          App: 2.3.7 (02.12.2021)
          <ul>
            <li>
              <strong>Verbesserungen im eFriends Shop</strong><br />
              Verbesserung der Ansicht für Kunden, die noch keinen gültigen
              Liefervertrag für Energiebezug haben.<br />
            </li>
          </ul>
        </li>
        <li>
          App: 2.3.6 (04.11.2021)
          <ul>
            <li>
              <strong>Verbesserungen in der Verlaufsansicht</strong><br />
              Die Verlaufsansicht zeigt nun für Produzenten gleichzeitig
              Verbrauch und Einspeisung an. Bisher wurde die Einspeisung nicht
              angezeigt, sobald in derselben Viertelstunde ein Verbrauch
              gemessen wurde.<br />
            </li>
            <li>
              <strong>eFriends Shop</strong><br />
              Im Kundenmenü (Klick auf Nickname) gibt es den neuen Eintrag
              "eFriends Shop". Dort können Zusatzpakete (EnergyLines,
              Funktionen, etc.) bestellt werden. Die Verrechnung erfolgt über
              die monatliche Abrechnung im Bereich "eFriends Service".<br />
            </li>
            <li>
              <strong>Expertenmodus</strong><br />
              Ausblenden der Funktion "eFriends Meter Setup" wenn eine andere
              Messhardware verwendet wird.<br />
            </li>
          </ul>
        </li>
        <li>
          App: 2.3.5 (03.11.2021)
          <ul>
            <li>
              <strong>Filter</strong><br />
              Anpassen der Preiseinstellung im Filter an die neue
              Tarifstruktur.<br />
            </li>
          </ul>
        </li>
        <li>
          App: 2.3.4 (25.10.2021)
          <ul>
            <li>
              <strong>Verbesserungen / Fehlerbehebungen</strong><br />
              In der Monatsansicht unter "Verbrauch" ändert der Button "Heute"
              das Datum zum Monatsersten anstatt des aktuellen Tages.<br />
              Auf den den Seiten "Aktuell" und "Verbrauch" wird jetzt der Name
              des aktuellen Providers gezeigt.<br />
            </li>
          </ul>
        </li>
        <li>
          App: 2.3.3 (21.10.2021)
          <ul>
            <li>
              <strong>Neue Funktion Monatsansicht</strong><br />
              Auf der Seite "Verlauf" kann nun auf eine Monatsansicht
              umgeschaltet werden. Diese zeigt Summen der Monate an.
              Zurückblätterbar bis August 2021.
            </li>
            <li>
              <strong>Meine Seite</strong><br />
              Fehlerbehebung auf Seite "Meine Daten" die zum Hängenbleiben der
              App führen konnte.
            </li>
            <li>
              <strong>Inaktive Seiten</strong><br />
              Fehlerbehandlung bei inaktiven / fehlerhaften Seitenadressen
              (404-Fehler).
            </li>
            <li>
              <strong>Strom spenden Anzeigefehler</strong><br />
              Ausblenden fehlerhafter Preisinformationen in der eFriends-Liste
              beim Strom spenden.
            </li>
          </ul>
        </li>
        <li>
          App: 2.3.2 (19.09.2021)
          <ul>
            <li>
              <strong>Verbesserungen</strong><br />
              Aktivierung des Device Managers für "Remote Cubes" (externe Cubes
              bei Beteiligungsprojekten)
            </li>
          </ul>
        </li>
        <li>
          App: 2.3.1 (15.09.2021)
          <ul>
            <li>
              <strong>Fehlerbehebungen</strong><br />
              Abfrage der Produzentenpreise konnte zu einem Fehler führen, und
              die Preise wurden nicht angezeigt.<br />
              Formattierungsfehler im Bereich "Mein Energiemix"
            </li>
          </ul>
        </li>
        <li>
          App: 2.3.0 (11.08.2021)
          <ul>
            <li>
              <strong>Device Manager</strong><br />
              Device Manager Funktionalität für das Einbinden und steuern von
              myStrom WiFi Steckdosen. Manuelles Schalten und Zeitschaltuhr.
              <br />
              Details unter:
              <a
                href="https://efriends.at/blog/neue-funktion-device-manager.html"
                target="_blank"
              >Blog Artikel</a
              >
            </li>
          </ul>
        </li>
        <li>
          App: 2.2.0 (09.06.2021)
          <ul>
            <li>
              <strong>Filterfunktion</strong><br />
              Eine Filterfunktion wurde eingefügt, mit der Cubes nach
              Produktionstyp, Preis, Entfernung gefiltert werden können.
              <br />
              Die Listen-/Ergebnisansicht zeigt zudem an, ob man sich zu dem
              Produzenten noch verbinden kann, Preisdetails sowie Entfernung.
            </li>
            <li>
              <strong>Sortierfunktion</strong><br />
              Es gibt nun die Möglichkeit, die Produzenten nach Preis oder
              Entfernung zu sortieren.
            </li>
            <li>
              <strong>Neue Icons und Map Marker</strong><br />
              Es werden neue Icons verwendet, die die Zugehörigkeit zum
              Energieanbieter sowie den Produktionstyp besser erkennen lassen.
            </li>
            <li>
              <strong>Menüführung</strong><br />
              Das Hauptmenü und das Benachrichtigungs-Menü wurden
              zusammengefasst. Die Benachrichtigungen sind nun im Hauptmenü als
              eigener Listenmenüpunkt ersichtlich.
            </li>
            <li>
              <strong>Benachrichtigungen</strong><br />
              Benachrichtigungen werden jetzt einfach per Klick als gelesen
              markiert. Man muss nicht mehr exakt den roten Punkt treffen.
            </li>
          </ul>
        </li>
        <li>
          App: 2.1.3 (13.04.2021)
          <ul>
            <li>
              <strong>Passwort-Reset Fehler behoben</strong><br />
              Mail Versand erfolgt nun zeitnah (&lt;1 Minute). Zudem wird der
              Benutzer darauf hingewiesen, dass bereits ein Passwort-Rücksetzen
              Prozess im Gange ist und kann ihn binnen 5 Minuten nicht erneut
              starten.<br />
              Der Request nach dem Neu-Eingeben des Passworts bleibt nicht mehr
              hängen.
            </li>
            <li>
              <strong>Trading Daten</strong><br />
              Die Trading-Daten werden nun nicht mehr nur 4x täglich in der
              Ansicht aktualisiert, sondern öfter, mit Ziel viertelstündlich
              (Frequenz wird in den nächsten Wochen sukzessive erhöht). Das
              sorgt für mehr Transparenz und die eFriends sehen noch schneller,
              von wem sie Energie bekommen bzw. mit wem sie Energie teilen.
            </li>
            <li>
              <strong>Trading Daten für Produzenten</strong><br />
              Produzenten sehen jetzt auch die Summen ihrer eigenen Produktion
              sowie die Menge an Strom, die an die Community geht.
            </li>
            <li>
              <strong>Prioritätsänderungen</strong><br />
              Änderungen an der Priorität werden nun auch in der Oberfläche
              sofort dargestellt. Bisher war ein Browser-Refresh notwendig.
            </li>
            <li>
              <strong>Bezug von Spendenempfängern</strong><br />
              Fehlerhafte Darstellung, wenn man an eine karitative Einrichtung
              spendet und gleichzeitig auch von dort bezieht, wurde korrigiert.
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="about__icons">
      Diese App verwendet die wunderbaren Icons von
      <a href="https://fontawesome.com/" target="_blank">Font Awesome</a> (<a
      href="https://fontawesome.com/license"
      target="_blank"
    >Lizenz</a
    >).<br /><br />
    </div>
  </div>
</template>

<script>
import IconExternal from '@/components/icons/External.vue'
import { useStrings } from '@/composables/useStrings.ts'
import { APP_VERSION, BACKEND_API_VERSION, REEM_API_VERSION, CUBE_API_VERSION } from '@/constants.ts'
export default {
  name: 'about',
  components: {
    IconExternal,
  },
  setup() {
    const { t } = useStrings()
    return {
      t,
      appVersion: APP_VERSION,
      backendApiVersion: BACKEND_API_VERSION,
      reemApiVersion: REEM_API_VERSION,
      cubeApiVersion: CUBE_API_VERSION,
    }
  }
}
</script>

<style lang="scss">
.about {
  &__data {
    border: 1px solid $grey-light;
    border-collapse: collapse;
  }
}
</style>
